export default "__VITE_ASSET__95d9c947__"